if ($(window).width() > 767) {
  $(window).scroll(function(){
          if ($(this).scrollTop() > 90) {
              $('header').addClass('sticky-header');
          } else {
              $('header').removeClass('sticky-header');
          }
      });
  $(window).scroll(function(){
          if ($(this).scrollTop() > 500) {
              $('.index header').addClass('sticky-header');
          } else {
              $('.index header').removeClass('sticky-header');
          }
      });
  }else{
    $(window).scroll(function(){
          if ($(this).scrollTop() > 90) {
              $('header').addClass('sticky-header');
          } else {
              $('header').removeClass('sticky-header');
          }
      });
  $(window).scroll(function(){
          if ($(this).scrollTop() > 340) {
              $('.index header').addClass('sticky-header');
          } else {
              $('.index header').removeClass('sticky-header');
          }
      });
  }
$(document).ready(function(){   
  $(".hamburger-bar").click(function(){
    $(".custom-menu-container").toggleClass('show')
    $(".overlay-box").toggleClass('show')
    $("header").toggleClass('white')
    $("html").toggleClass('MyClass')
  });
  $(".close-icon").click(function(){
    $(".custom-menu-container").removeClass('show')
    $(".overlay-box").removeClass('show')
    $("header").removeClass('white')
    $("html").removeClass('MyClass')
  });
  $(".overlay-box").click(function(){
    $(".custom-menu-container").removeClass('show')
    $(this).removeClass('show')
    $("html").removeClass('MyClass')
  });
  $(".mega-menu-list .menu-li span").click(function(e){
    e.preventDefault();
    $(this).toggleClass('drop')
    $(this).parent('.mega-menu-list .menu-li').find('.Submega-menu').toggleClass('show')
    $(this).parents('details').attr('open')
    $(this).parents('summary').attr('aria-expanded', 'true')
    // if () {      
    // }
  });
  $(".list-menu.list-menu--inline li .MainList-head").click(function(){
    $(this).toggleClass('active')
    $(this).parent('.list-menu.list-menu--inline li').find('.mega-menu-content').toggleClass('show')
  });
  
});